import { action } from 'typesafe-actions';
import { GestaoAgendamentoTypes, IGestaoAgendamento, IFiltroMovi, Pagination } from './types';

export const loadRequest = (filtro: IFiltroMovi | any, inscricaoAtiva: number | undefined, 
  cddAtivo: number | undefined, pagination?: Pagination) => 
  action(GestaoAgendamentoTypes.LOAD_REQUEST, { filtro, inscricaoAtiva, cddAtivo, pagination});
export const loadSuccess = (data: IGestaoAgendamento[],  pagination: Pagination) => 
  action(GestaoAgendamentoTypes.LOAD_SUCCESS, { data, pagination });
export const loadFailure = () => action(GestaoAgendamentoTypes.LOAD_FAILURE);
